import React from 'react';
import CRMPage from './CRMPage';

// Export CRMPage as default for backward compatibility
export default CRMPage;

// Also export CRMModule as a named export if needed elsewhere
export const CRMModule = CRMPage; 